const userAgent = ((navigator && navigator.userAgent) || '').toLowerCase();

export const isIe = () => /(?:msie |trident.+?; rv:)(\d+)/.test(userAgent);
